import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// DELETE /api/settings/announcements/:id
//
// Removes the row outright. Replaces revalidatePath("/admin/settings").
export function useDeleteAnnouncement() {
  const queryClient = useQueryClient();
  return useMutation<{ ok: true }, ApiClientError, string>({
    mutationFn: (id) =>
      apiFetch<{ ok: true }>(`/settings/announcements/${id}`, {
        method: "DELETE",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.settings.announcements() });
      queryClient.invalidateQueries({ queryKey: queryKeys.notifications.inbox() });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to delete announcement");
    },
  });
}
